import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import DayJsUtils from '@date-io/dayjs'
import fr from 'dayjs/locale/fr'
import UIInput from '../../components/UI/UIInput'
import IconClock from '../Icon/IconClock'

function UITimePickers({
  onTimeChange,
  errorMessage,
  inputTimeValue,
  icon,
  placeholder,
  ...props
}) {
  const handleTimeChange = (value) => {
    onTimeChange(value)
  }

  const [timeValue, setTimeValue] = useState('')
  const [isPickerTimeOpen, setIsPickerTimeOpen] = useState(false)

  function pad(num, size) {
    num = num.toString()
    while (num.length < size) num = '0' + num
    return num
  }

  const TextFieldComp = ({ placeholder, errorMessage }) => {
    return (
      <UIInput
        placeholder={placeholder}
        value={timeValue}
        onClick={() => setIsPickerTimeOpen(true)}
        errorMessage={errorMessage}
        icon={icon ? <IconClock /> : null}
      />
    )
  }

  const customTheme = createTheme({
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: '#B9AA00',
        },
      },
      MuiPickersClock: {
        pin: {
          backgroundColor: '#B9AA00',
        },
      },
      MuiPickersClockPointer: {
        pointer: {
          backgroundColor: '#B9AA00',
        },
        noPoint: {
          backgroundColor: '#B9AA00',
        },
        thumb: {
          border: '14px solid #B9AA00',
        },
      },
      MuiButton: {
        textPrimary: {
          color: '#B9AA00',
        },
      },
    },
  })

  return (
    <ThemeProvider theme={customTheme}>
      <MuiPickersUtilsProvider utils={DayJsUtils} ampm={false} locale={fr}>
        <KeyboardTimePicker
          {...props}
          ampm={false}
          variant="inline"
          format="hh:mm"
          placeholder={placeholder}
          value={inputTimeValue}
          onClose={() => setIsPickerTimeOpen(false)}
          open={isPickerTimeOpen}
          onChange={handleTimeChange}
          errorMessage={errorMessage}
          onAccept={(date) => {
            setTimeValue(pad(date.$H, 2) + ':' + pad(date.$m, 2))
          }}
          TextFieldComponent={(props) => {
            return <TextFieldComp {...props} />
          }}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}

UITimePickers.propTypes = {
  onTimeChange: PropTypes.func,
  value: PropTypes.instanceOf(Date),
  errorMessage: PropTypes.string,
  isPickerTimeOpen: PropTypes.bool,
  inputTimeValue: PropTypes.string,
  setInputTimeValue: PropTypes.func,
  closeTimePicker: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.bool,
}

export default UITimePickers
